{
  "sl-SI": {
    "model": {
      "profile": {
        "id": "ID uporabnika",
        "userName": "Uporabniško ime",
        "email": "Naslov elektronske pošte",
        "emailConfirmed": "E-poštni naslov je potrjen.",
        "phoneNumber": "Številka telefona",
        "phoneNumberConfirmed": "Številka telefona je potrjena.",
        "twoFactorEnabled": "Omogočeno dvofaktorsko preverjanje identitete.",
        "lockoutEnd": "Datum, ko se zaključi obdobje blokade.",
        "lockoutEnabled": "Funkcija blokiranja je omogočena.",
        "accessFailedCount": "Število neuspešnih poskusov dostopa.",
        "firstName": "Ime",
        "lastName": "Priimek",
        "picture": "Slika profila.",
        "organisationName": "Organizacija",
        "name": "Ime",
        "roles": "Vloge"
      }
    },
    "profileManager": {
      "column": {
        "emailConfirmed": "Potrjeno"
      },
      "action": {
        "resetPassword.tooltip": "Pošljite navodila za ponastavitev gesla uporabniku po e-pošti."
      },
      "message": {
        "resetPassword.success": "Uporabniku je bilo poslano e-poštno sporočilo z navodili za ponastavitev gesla."
      }
    }
  }
}